import { forwardRef } from 'react'

const Card = forwardRef(({ children, className = '' }, ref) => {
  return (
    <div ref={ref} className={`rounded-[30px] p-5 ${className}`}>
      {children}
    </div>
  )
})

const CardContent = ({ children }) => {
  return (
    <div className="flex flex-col items-center text-primary">
      {children}
    </div>
  )
}

export { Card, CardContent }